import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { SocialMediaEnum } from "src/app/enums/socialMedia.enum";

export class SocialMedia extends FBase {

  link: string = null;
  tooltip: string = null;
  icon: string = null;
  socialMedia: SocialMediaEnum = null;


  constructor(json?: { [key: string]: any }) {
    super();
    if (isObject(json)) {
      this.fromJson(json);
    }
  }

}
export namespace SocialMedia {
  export const PATH = 'socialMedia';
}
